/**
 * @ngdoc service
 * @name tracking
 * @description
 * The service to track events on Google Analytics.
 *
 * @memberof common
 */
class Tracking {
  /**
   * Class constructor.
   * @param {Service} $analytics   The `angulartics` service for the tracking.
   * @param {Object}  $window      To access google analytics.
   * @param {Object}  appConstant  The app configuration dictionary.
   * @ignore
   */
  constructor(
    $analytics,
    $window,
    appConstant,
  ) {
    'ngInject';

    /**
     * The local reference to the `$analytics` service.
     * @type {Object}
     */
    this.$analytics = $analytics;
    /**
     * The local reference to the `analytics` object.
     * @type {Object}
     */
    this.analytics = appConstant.features.analytics;
    /**
     * The local reference to the `customer` object.
     * @type {Object}
     */
    this.customer = {};

    if (this.analytics.enabled && $window.ga) {
      $window.ga('create', this.analytics.id, 'auto');
    }
  }
  /**
   * Set the customer information to be used when tracking.
   * @param  {Object}  customer  The event to track.
   *
   */
  setCustomer(customer) {
    this.customer = customer;

    if (this.analytics.enabled) {
      this.$analytics.setUserProperties({
        dimension1: this.customer.name,
        dimension6: this.customer.id,
      });
    }
  }
  /**
   * Track an event on the `$analytics` service.
   * @param  {Event}   event       The event to track.
   * @param  {String}  event.name  The name of the event should be a string with the event
   *                               category and event action splited with a pipe `|`.
   *
   */
  trackEvent(event) {
    if (this.analytics.enabled) {
      const [eventCategory, eventAction] = event.name.split('|');
      this.$analytics.eventTrack(eventAction, {
        category: `${this.analytics.eventsPrefix}${eventCategory}`,
        label: this.customer.name,
      });
    }
  }
}

export default Tracking;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/services/tracking.js